<template>
  <div>
    <section>
      <!-- Just an image -->
      <div class="outer-menu" style="z-index: 7777">
        <input class="checkbox-toggle" type="checkbox" />
        <div class="hamburger">
          <div></div>
        </div>
        <div class="menu">
          <div>
            <div>
              <ul>
                <li>
                  <router-link :to="{ name: 'home' }" class="text-white">
                    Home
                  </router-link>
                </li>
                <!-- <li><router-link :to="{name: 'regshop', params:{plan: 'Premium'}}" class="text-white"> Create Store</router-link></li> -->
                <li>
                  <router-link
                    v-if="admin"
                    :to="{ name: 'admin' }"
                    class="text-white"
                  >
                    Admin</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-if="pageadmin"
                    :to="{ name: 'admin-services' }"
                    class="text-white"
                  >
                    Admin</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-if="visitor"
                    :to="{ name: 'signin' }"
                    class="text-white"
                  >
                    Sign in</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-if="visitor"
                    :to="{ name: 'usersignup' }"
                    class="text-white"
                  >
                    Sign up</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-if="user"
                    :to="{ name: 'myaccount' }"
                    class="text-white"
                  >
                    My Account</router-link
                  >
                </li>
                <li>
                  <a
                    style="cursor: pointer"
                    @click="logout()"
                    v-if="user || admin || pageadmin"
                    class="text-white"
                  >
                    Sign out</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="">
      <section>
        <nav class="navbar" style="background-color: #180000">
          <a class="navbar-brand" href="#">
            <img src='../../static/img/logo/Logo2.jpeg' width="50" height="50" alt="eshops-logo" />
          </a>
          <div class="d-nav">
            <router-link :to="{ name: 'home' }" class="text-white mr-5">
              Home
            </router-link>
            <!-- <router-link :to="{name: 'regshop', params:{plan: 'Premium'}}" class="text-white mr-5"> Create Store</router-link> -->
            <router-link
              v-if="admin"
              :to="{ name: 'admin' }"
              class="m-link text-white mr-5"
              >Admin</router-link
            >
            <router-link
              v-if="pageadmin"
              :to="{ name: 'admin-services' }"
              class="m-link text-white mr-5"
              >Admin</router-link
            >
            <router-link
              v-if="visitor"
              :to="{ name: 'signin' }"
              class="m-link text-white mr-5"
              >Sign in</router-link
            >
            <router-link
              v-if="visitor"
              :to="{ name: 'usersignup' }"
              class="m-link text-white mr-5"
              >Sign up</router-link
            >
            <router-link
              v-if="user"
              :to="{ name: 'myaccount' }"
              class="m-link text-white mr-5"
              >My Account</router-link
            >
            <a
              style="cursor: pointer"
              @click="logout()"
              v-if="user || admin || pageadmin"
              class="text-white mr-5"
              >Sign out</a
            >
          </div>
        </nav>
      </section>
    </div>
    <div class="container mt-3 py-5">
      <div class="row col-md-8 col-lg-6 mx-auto">
        <h1
          class="text-center text-dark display-4 mx-auto mb-4"
          style="font-weight: bold"
        >
          We Develop Our Little Island Not just Businesses. Because It's Our
          Country.
        </h1>
        <div class="mx-auto">
          <img
            src='../../static/img/logo/Logo2.jpeg' width="240" height="240"
            alt="eshops.lk-logo"
            class="img-fluid"
          />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row col-md-8 col-lg-6 mx-auto">
        <h1
          class="text-center text-dark display-4 mx-auto my-4"
          style="font-weight: bold"
        >
          We Are Here To Raise Our Nation On Modern Technology.
        </h1>
        <div class="mx-auto">
          <img
            src="../../static/img/offing-logo.png"
            alt="offing-logo"
            class="img-fluid ml-3 text-center"
          />
          <h3
            class="text-center text-dark mx-auto my-2 pb-5"
            style="font-weight: 700"
          >
            Offing Tech (Pvt Ltd)
          </h3>
        </div>
      </div>
    </div>
    <div class="container">
      <h2
        class="text-center text-dark mx-auto mt-2 mb-3"
        style="font-weight: 800"
      >
        Contact Us
      </h2>
      <div class="row col-md-8 col-lg-6 mx-auto">
        <div class="mx-auto text-center mb-4">
          <h5 class="my-3">
            <i class="fa fa-phone fa-1x mr-2"></i>0719 500 600
          </h5>
          <!-- <h5 class="my-3"><i class="fa fa-map-marker fa-1x mr-2"></i>No 321/3d, Peredeniya, Kandy</h5>     -->
          <h5 class="my-3">
            <i class="fa fa-envelope fa-1x mr-2"></i>info@eshops.lk
          </h5>
        </div>
      </div>
    </div>

    <footer class="footer section section-sm">
      <!-- Container Start -->
      <div class="container">
        <div class="row justify-content-around">
          <!-- <div class="col-lg-3 col-md-7 offset-md-1 offset-lg-0">
        
        <div class="block about">
         
          <img src="images/logo-footer.png" alt="">
          
          <p class="alt-color text-secondary">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
        </div>
         <ul class="social-media-icons mb-3">
              <li><a class="fa fa-facebook" href=""></a></li>
              <li><a class="fa fa-twitter" href=""></a></li>
              <li><a class="fa fa-pinterest-p" href=""></a></li>
              <li><a class="fa fa-vimeo" href=""></a></li>
            </ul>
      </div> -->
          <!-- Link list -->
          <div class="col-sm-6 col-lg-3">
            <div class="block block-link">
              <h4>Site Pages</h4>
              <ul>
                <li class="px-0">
                  <router-link :to="{ name: 'home' }">Home</router-link>
                </li>
                <!-- <li><router-link :to="{name: 'regshop', params:{plan: 'Premium'}}">Create Store</router-link></li> -->
                <li>
                  <router-link :to="{ name: 'about' }">About Us</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'termsofuse' }"
                    >Terms of Use</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: 'privacypolicy' }"
                    >Privacy Policy</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- Link list -->
          <div class="col-sm-6 col-lg-4">
            <div class="block block-info">
              <h4>Contact Us</h4>
              <ul>
                <li>
                  <a
                    ><i class="fa fa-phone mr-2" aria-hidden="true"></i>0719 500
                    600</a
                  >
                </li>
                <!-- <li>
                  <a
                    ><i class="fa fa-phone mr-2" aria-hidden="true"></i
                    >0113-601-444</a
                  >
                </li> -->
                <li>
                  <a
                    ><i class="fa fa-envelope mr-2" aria-hidden="true"></i
                    >info@eshops.lk</a
                  >
                </li>
              </ul>
              <ul class="social-media-icons mb-2 d-inline">
                <li style="">
                  <a
                    href="https://www.facebook.com/Eshopslk-2212428785713128/"
                    class="px-0 ml-0 mr-2"
                    ><i
                      class="fa fa-facebook-official f-sm-link"
                      style="
                        font-size: 34px;
                        color: #3b5998;
                        background-color: #fff;
                        width: 30px;
                        height: 30px;
                        border-radius: 4px;
                        text-align: center;
                        vertical-align: middle;
                      "
                    ></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/eshops.lk/"
                    class="px-0 mx-2"
                    ><i
                      class="fa fa-instagram f-sm-link"
                      style="
                        font-size: 30px;
                        color: #fff;
                        background: #d6249f;
                        background: radial-gradient(
                          circle at 30% 107%,
                          #fdf497 0%,
                          #fdf497 5%,
                          #fd5949 45%,
                          #d6249f 60%,
                          #285aeb 90%
                        );
                        width: 32px;
                        height: 32px;
                        border-radius: 4px;
                        text-align: center;
                        vertical-align: middle;
                      "
                    ></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"
                    class="px-0 mx-2"
                    ><i
                      class="fa fa-youtube-square f-sm-link"
                      style="
                        font-size: 35px;
                        color: #ff0000;
                        background-color: #fff;
                        width: 30px;
                        height: 30px;
                        border-radius: 6px;
                        text-align: center;
                        vertical-align: middle;
                      "
                    ></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
          <!-- Promotion -->
          <div class="col-sm col-md-8 col-lg-5">
            <!-- App promotion -->
            <div class="block-2 app-promotion">
              <a>
                <!-- Icon -->
                <img
                  src="../../static/img/icons/footer-android-chrome-90x90.png"
                  alt="mobile-icon"
                />
              </a>
              <p class="m-f-text">
                Tap the Add to Home Screen Tab in Chrome Browser on Android or
                Safari Browser on IOS to Get the Splendid
                <span style="color: #fd6a02; font-size: 20px">Mobile App</span>
                Directly
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Container End -->
    </footer>
    <!-- Footer Bottom -->
    <footer class="footer-bottom">
      <!-- Container Start -->
      <div class="container">
        <div class="row">
          <div class="col-12 mx-auto mt-5">
            <div class="copyright text-center mx-auto">
              <img src="../../static/img/eshops-logo.png" alt="eshops-logo" />
              <p class="m-f-text text-center mt-2">
                © {{ new Date().getFullYear() }} eshops.lk | All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- Container End -->
      <!-- To Top -->
    </footer>
    <!-- <button class="goTop" v-if="isVisible" @click="backToTop">
        <i class="fa fa-angle-up text-white" aria-hidden="true"></i>
    </button> -->
    <!-- <back-to-top bottom="50px" right="50px">
  <button type="button" class="btn btn-info btn-to-top"><i class="fa fa-chevron-up"></i></button>
</back-to-top> -->
  </div>
</template>

<script>
import db from "../config/FirebaseInit";
import firebase from "firebase/app";
export default {
  name: "about",
  data() {
    return {
      isVisible: false,
      user: false,
      visitor: false,
      admin: false,
      starterplanadmin: false,
      pageadmin: false,
    };
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("/");
        });
    },

    scrollWin() {
      window.scrollBy(0, 800);
    },
  },
  created() {
    if (firebase.auth().currentUser) {
      if (firebase.auth().currentUser.displayName == null) {
        this.user = true;
      } else if (
        firebase.auth().currentUser.displayName == "shop owner" ||
        firebase.auth().currentUser.displayName == "starterplan shop owner"
      ) {
        this.admin = true;
      } else if (firebase.auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      }
    } else {
      this.visitor = true;
    }

    this.$nextTick(function () {
      // this.initToTopButton();
    });
  },
};
</script>

<style scoped>
@import url("~@/assets/main/css/styles.css");
@import url("~@/assets/main/css/nav.css");

.goTop {
  cursor: pointer;
  border-radius: 5px;
  background-color: rgb(1, 14, 27);
  background-color: rgba(1, 14, 27, 0.7);
  position: fixed;
  width: 45px;
  height: 45px;
  display: block;
  right: 15px;
  bottom: 15px;
  border: none;
  opacity: 0;
  z-index: -1;
}
.isVisible {
  opacity: 0.8;
  z-index: 4;
  transition: all 0.4s ease-in;
}
@media (max-width: 1040px) {
  h1 {
    font-size: 36px;
  }
}
@media (max-width: 767px) {
  .d-nav {
    display: none;
  }
  h1 {
    font-size: 32px;
  }
}
@media (max-width: 575px) {
  .m-link {
    font-size: 14px;
  }
  .m-f-text {
    font-size: 12px;
  }
  .footer .block ul li a {
    font-size: 12px;
  }
  h1 {
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue